import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { getCertificateDetails, getCertificateIDDetails } from "./api";

const useVerifiCertificate = () => {
  const [certificateData, setCertificateData] = useState(null);
  const [certificateId, setCertificateId] = useState("");
  const [error, setError] = useState(null);
  const [searchError, setSearchError] = useState(null);
  const [isSearching, setIsSearching] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  useEffect(() => {
    const queryString = window?.location?.search;
    const cardId = queryString?.slice(1);
    if (!cardId) {
      setError("Invalid Certificate");
      return;
    }
    getCertificateDetails(cardId).then((response) => {
      if (response?.data?.status_code === 200) {
        setCertificateData(response?.data?.data);
        setError(null);
      } else if (response?.status_code === 422) {
        setError("Invalid Certificate");
      } else {
        setError("Something went wrong");
      }
    });
  }, []);

  const handleChange = (e) => {
    setCertificateId(e.target.value);
    setSearchError(null);
  };

  const handleSubmit = () => {
    const trimmedId = certificateId?.trim();
    if (!trimmedId) {
      toast.error("Invalid certificate");
      return;
    }
    setIsSearching(true);
    getCertificateIDDetails({ certificate_number: trimmedId })
      .then((response) => {
        if (response?.data?.status_code === 200) {
          setCertificateData(response?.data?.data);
          setSearchError(null);
          setError(null);
        } else if (response?.status_code === 422) {
          setSearchError("Invalid Certificate");
        } else {
          setSearchError("Something went wrong");
        }
      })
      .catch(() => {
        setSearchError("Something went wrong");
      })
      .finally(() => {
        setIsSearching(false);
      });
  };

  const handleDownloadOldCertificate = async () => {
    if (!certificateData?.file_path) return;
    try {
      setIsDownloading(true);
      const response = await fetch(certificateData.file_path);
      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob);
      const extension = blob.type?.split("/")?.[1]?.split("+")?.[0] || "png";
      const fileName = `${
        certificateData?.certificate_number || certificateId || "certificate"
      }.${extension}`;
      const link = document.createElement("a");
      link.href = objectUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(objectUrl);
    } catch {
      toast.error("Something went wrong");
    } finally {
      setIsDownloading(false);
    }
  };

  return {
    error,
    searchError,
    isSearching,
    isDownloading,
    handleDownloadOldCertificate,
    certificateId,
    handleChange,
    handleSubmit,
    certificateData,
  };
};

export default useVerifiCertificate;
